import ConfidoHostedField from './ConfidoHostedField';

export default ConfidoHostedField;